import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"grid-list-m":""}},[_c(VLayout,{attrs:{"wrap":""}},[_c(VFlex,{attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[(true)?_c('div',[_c('canvas',{attrs:{"id":"myChart"}})]):_vm._e()])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }